import { render } from "./MediaPlayer.vue?vue&type=template&id=99067552&scoped=true"
import script from "./MediaPlayer.vue?vue&type=script&lang=js"
export * from "./MediaPlayer.vue?vue&type=script&lang=js"

import "./MediaPlayer.vue?vue&type=style&index=0&id=99067552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99067552"]])

export default __exports__